import { createClient } from '@supabase/supabase-js';

// Tenta buscar variáveis de ambiente em diferentes formatos (Correção para Deploy Vercel)
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.VITE_SUPABASE_SUPABASE_URL || import.meta.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_SUPABASE_ANON_KEY || import.meta.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase URL or Anon Key is missing in environment variables. Checked: VITE_SUPABASE_URL, VITE_SUPABASE_SUPABASE_URL');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
